<template>
  <div class="div-history-evaluation">
    <div class="options-btn">
      <el-button size="mini" @click="agendaAnterior = !agendaAnterior;">{{ btnText }}</el-button>
    </div>
    <el-table
      class="table-history"
      :data="tableData"
      border
      style="width: 100%;"
    >
      <el-table-column
        prop="date"
        label="Fecha"
        width="100"
      />
      <el-table-column
        prop="time"
        label="Hora"
        width="70"
      />
      <el-table-column
          label="Creador Por">
        <template slot-scope="scope">
          <label>{{tableData[scope.$index].creatorFirstName}}&nbsp;</label>
          <label>{{tableData[scope.$index].creatorLastName}}</label>
        </template>
      </el-table-column>
      <el-table-column
          label="Agenda">
        <template slot-scope="scope">
          <label>{{tableData[scope.$index].userFirstName}}&nbsp;</label>
          <label>{{tableData[scope.$index].userLastName}}</label>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="Tipo"
        width="170"
      />
      <el-table-column
        prop="subject"
        width="110"
        v-if="!agendaAnterior"
      />
      <el-table-column
        label="Operación"
        width="120">
        <template slot-scope="scope">
          <router-link
            :to='`/admin/evaluations/oftahistory/${idpatient}/${idApointment.id}`'
            v-if="agendaAnterior"
          >
            <el-button
              v-if="tableData[scope.$index].subject != 'Gabinete'"
              type="primary"
              size="mini"
              plain
              @click="rowSelect(scope.$index, scope.row)"
            >
              Visualizar
            </el-button>
          </router-link>
          <router-link
            :to='`/admin/evaluations/oftahistoryNuevo/${idpatient}/${idApointment.id}`'
            v-if="!agendaAnterior"
          >
            <el-button
              v-if="tableData[scope.$index].subject != 'Gabinete'"
              type="primary"
              size="mini"
              plain
              @click="rowSelect(scope.$index, scope.row)"
            >
              Visualizar
            </el-button>
          </router-link>
      </template>
    </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    patientId: {
      type: Number,
    },
  },
  data() {
    return {
      btnText: 'Mostrar historial actual',
      agendaAnterior: false,
      idpatient: '',
      idApointment: '',
      tableData: [],
    };
  },
  methods: {
    rowSelect(row) {
      this.idApointment = this.tableData[row];
    },
    async mostrarAgendaAnterior() {
      try {
        /* eslint-disable no-unused-expressions */
        this.btnText === 'Mostrar historial anterior' ? this.btnText = 'Mostrar historial actual' : this.btnText = 'Mostrar historial anterior';
        const response = await this.axios.get(`patient/appointment/md/history/${this.patientId}`);
        const { data } = response;
        if (data) {
          this.tableData = data;
          for (let i = 0; i < data.length; i++) {
            if (data[i].user === null) {
              data[i].user = 'desconocido';
            }
          }
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
    async getAppointments() {
      try {
        /* eslint-disable no-unused-expressions */
        this.btnText === 'Mostrar historial anterior' ? this.btnText = 'Mostrar historial actual' : this.btnText = 'Mostrar historial anterior';
        const response = await this.axios.get(`patient/appointment/md/historySubsecuent/${this.patientId}`);
        const { data } = response;
        if (data) {
          this.tableData = data;
          for (let i = 0; i < data.length; i++) {
            if (data[i].user === null) {
              data[i].user = 'desconocido';
            }
          }
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
  },
  mounted() {
    this.getAppointments();
  },
  created() {
    this.idpatient = this.patientId;
  },
  watch: {
    patientId(val) {
      if (val) {
        this.getAppointments();
      }
    },
    agendaAnterior(val) {
      if (val === true) {
        this.mostrarAgendaAnterior();
      } else {
        this.getAppointments();
      }
    },
  },
};
</script>
<style lang="scss">
.options-btn{
  display: flex;
  align-items: center;
  justify-content: right;
  margin: 10px 5px 10px 0;

  .el-button{
    background-color: #6a41bdbc;
    color: #fff;
  }
}
</style>
<style lang="scss">
@import './styles/history.scss';
</style>
